import React, { useEffect, useState } from 'react'
import createAirlineCommission from '../../../../controllers/settings/AirlineCommission/createAirlineCommission';
import { enqueueSnackbar } from 'notistack';
import AirlinesInput from '../../../../components/form/AirlinesInput';
import TextInput from '../../../../components/form/TextInput';
import Button1 from '../../../../components/form/Button1';
import updateAirlineCommission from '../../../../controllers/settings/AirlineCommission/updateAirlineCommission';


const initData = {
    airline: '',
    commission: null,
}

export default function AirlineCommissionForm({data:defData,callback,close}) {
       const [data,setData] = useState(initData)
        const [loadings,setLoadings] = useState({submit: false})
    
        useEffect(() => {
            setData({...initData,...(defData||{})})
        },[defData,close])

        console.log(data,' < == ')
            
        async function handleSubmit(ev) {
            ev?.preventDefault();
    
            const payload = {...data,
                commission: Number(data?.commission)
            }
            
            setLoadings({...loadings,submit: true})
            let res = {return: false, msg: 'Something went wrong on our end! 0XACF'};

            if(!defData)
                res = await createAirlineCommission(payload);
            else 
                res = await updateAirlineCommission(defData?._id,payload)
            setLoadings({...loadings,submit: false})
            if(res?.return) {
                enqueueSnackbar(res?.msg,{variant: 'success'})
                callback && callback()
                close && close();
            } else enqueueSnackbar(res?.msg,{variant: 'error'})
        }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-10 min-w-[400px]'>
        <AirlinesInput label='Airline' val={data?.airline} returnData={(val) => setData({...data,airline: val?.id || val}) } />
        <TextInput label='Commission' type='number'
            value={data?.commission} onChange={(ev) => setData({...data,commission: Number(ev.target.value)})} />
        <div className='flex gap-4 items-center'>
            {close ? 
                <div>
                    <Button1 variant='outlined' type='button' onClick={() => close(false)}>Close</Button1>
                </div>
            :null}
            <Button1 type='submit' loading={loadings?.submit}>{!defData?'Add':'Update'}</Button1>
        </div>
    </form>
  )
}
